import Support from 'modules/acount/support';
import Header from 'modules/header/wholesaler/main';

const SupportPage = () => {
  return (
    <>
      <Header title="پشتیبانی" />
      <Support />
    </>
  );
};

export default SupportPage;
